<!-- claw and rod -->
<div class="pointer-events-none relative inline select-none" [style.width.px]="size()" [style.height.px]="size()">
  <!-- right jaw -->
  <div
    class="absolute origin-top -translate-y-[80%] transition-transform"
    [ngStyle]="{
      transform: opened() ? 'rotate(-25deg)' : 'rotate(-1deg)',
      width: 11 * size() + 'px',
    }"
  >
    <img [src]="spritePath + 'claw-right.png'" class="object-contain" />
  </div>
  <!-- body -->
  <div
    class="pointer-events-none absolute origin-center -translate-x-1/2 -translate-y-[130%] transition-transform select-none"
    [style.width.px]="24 * size()"
  >
    <img class="size-full object-contain" [src]="spritePath + 'claw-body.png'" />
  </div>
  <!-- light -->
  <div class="absolute -translate-x-1/2 -translate-y-[105%]" [style.width.px]="48 * size()" [style.height.px]="48 * size()">
    <img class="size-full object-contain" [src]="lightAssetPath()" />
  </div>
  <!-- rod -->
  <div
    class="absolute bottom-[42px] left-1/2 -translate-x-[30%] bg-gradient-to-r from-gray-200 to-gray-600"
    [style.width.px]="4 * size()"
    [style.height.px]="2000 * size()"
    [style.bottom.px]="42 * size()"
  ></div>
</div>
